import dayjs from 'dayjs'

const DATE = 'MMM D, YYYY'
const DATE_TIME = 'MMM D, YYYY, h:mm A'

export const convertToDateTime = (date) => (date ? dayjs(date).format(DATE_TIME) : 'N/A')

export const convertToWithTimezone = (date) => (date ? dayjs(date).format(DATE_TIME) : 'N/A')

export const convertToFromNow = (date) => dayjs.utc(date).fromNow()

export const convertToShorthand = (date) => (date ? dayjs.utc(date).format(DATE) : 'N/A')

export const convertToShorthandWithTime = (date) => (date ? dayjs(date).format(DATE_TIME) : 'N/A')

export const convertToShorthandWithTimezone = (date) => (date ? dayjs(date).format(DATE_TIME) : 'N/A')

export const convertToMonth = (date) => (date ? dayjs.utc(date).format('MMM YYYY') : 'N/A')

export const convertToLongDate = (date) => (date ? dayjs.utc(date).format(DATE) : 'N/A')
